module.exports = __webpack_public_path__ + "static/media/apple.d2fcc4ab.svg";